import type { PackagingOption } from '../../../graphql/query/getDelivery';

export const getId = ({
  moniker,
  type,
  packageType,
}: {
  moniker?: string | null;
  type: string;
  packageType?: string;
}) => `${type}.${moniker}.${packageType}`;

type DeliveryType = 'Mail' | 'Printerless' | 'Store' | 'ShipOnYourOwn' | 'None';

type DeliveryBreakdown = {
  id: string;
  name?: string | null;
  packagingOption?: PackagingOption;
  serviceType?: string | null;
};

export const getDeliveryType = ({
  id,
  packagingOption,
}: DeliveryBreakdown): DeliveryType => {
  const normalizedId = id.toLowerCase();
  if (
    normalizedId === 'ship_on_your_own' ||
    normalizedId.startsWith('ship_on_your_own')
  )
    return 'ShipOnYourOwn';
  if (normalizedId === 'return_in_store' || normalizedId.includes('in_store'))
    return 'Store';
  if (packagingOption === 'PRINTERLESS') {
    return `Printerless`;
  }
  if (packagingOption === 'NONE') {
    return 'None';
  }
  return 'Mail';
};

export const getLabel = ({
  id,
  name,
  packagingOption,
  serviceType,
}: DeliveryBreakdown): string[] => {
  // TODO: These ids should be better formatted in graphql
  const deliveryType = getDeliveryType({ id, packagingOption });
  const normalizedId = id.toLowerCase();
  if (
    normalizedId === 'ship_on_your_own' ||
    normalizedId.startsWith('ship_on_your_own') ||
    normalizedId === 'return_in_store'
  ) {
    return [`Global.delivery.type.${deliveryType}`];
  }
  if (packagingOption === 'PRINTERLESS' || name) {
    const baseDeliveryKeys = [
      `Global.delivery.type.${deliveryType}.${name}`,
      `Global.delivery.type.${deliveryType}`,
    ];
    return serviceType
      ? [
          `Global.delivery.type.${deliveryType}.${name}.${serviceType}`,
          ...baseDeliveryKeys,
        ]
      : baseDeliveryKeys;
  }
  return [`Global.delivery.type.${deliveryType}`];
};
